import React, { useEffect, useState } from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { FramingBand } from './components/FramingBand';
import { ProblemSection } from './components/ProblemSection';
import { PlatformOverview } from './components/PlatformOverview';
import { OperatingModel } from './components/OperatingModel';
import { CapabilityDomains } from './components/CapabilityDomains';
import { HumanOpportunity } from './components/HumanOpportunity';
import { LifecycleArchitecture } from './components/LifecycleArchitecture';
import { Solutions } from './components/Solutions';
import { ProductEcosystem } from './components/ProductEcosystem';
import { GlobalArchitecture } from './components/GlobalArchitecture';
import { LeadershipReadiness } from './components/LeadershipReadiness';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { CJIPage } from './components/CJIPage';
import { NCJIPage } from './components/NCJIPage';
import { SolutionsPage } from './components/SolutionsPage';
import { AboutPage } from './components/AboutPage';
import { ResearchPage } from './components/ResearchPage';
import { PartnershipsPage } from './components/PartnershipsPage';
import { ContactPage } from './components/ContactPage';
import { PrivacyPolicyPage } from './components/PrivacyPolicyPage';
import { TermsOfServicePage } from './components/TermsOfServicePage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1) || 'home';
      setCurrentPage(hash);
      window.scrollTo(0, 0);
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  const renderPage = () => {
    switch (currentPage) {
      case 'cji':
        return <>
            <CJIPage data-id="element-0" />
            <FinalCTA data-id="element-1" />
          </>;
      case 'ncji':
        return <>
            <NCJIPage data-id="element-2" />
            <FinalCTA data-id="element-3" />
          </>;
      case 'solutions':
        return <>
            <SolutionsPage data-id="element-4" />
            <FinalCTA data-id="element-5" />
          </>;
      case 'about':
        return <>
            <AboutPage data-id="element-6" />
            <FinalCTA data-id="element-7" />
          </>;
      case 'research':
        return <>
            <ResearchPage data-id="element-8" />
            <FinalCTA data-id="element-9" />
          </>;
      case 'partnerships':
        return <>
            <PartnershipsPage data-id="element-10" />
            <FinalCTA data-id="element-11" />
          </>;
      case 'contact':
        return <>
            <ContactPage data-id="element-12" />
            <FinalCTA data-id="element-13" />
          </>;
      case 'privacy':
        return <PrivacyPolicyPage data-id="element-14" />;
      case 'terms':
        return <TermsOfServicePage data-id="element-15" />;
      case 'home':
      default:
        return <>
            <HeroSection data-id="element-16" />
            <FramingBand data-id="element-17" />
            <ProblemSection data-id="element-18" />
            <PlatformOverview data-id="element-19" />
            <OperatingModel data-id="element-20" />
            <CapabilityDomains data-id="element-21" />
            <HumanOpportunity data-id="element-22" />
            <LifecycleArchitecture data-id="element-23" />
            <Solutions data-id="element-24" />
            <ProductEcosystem data-id="element-25" />
            <GlobalArchitecture data-id="element-26" />
            <LeadershipReadiness data-id="element-27" />
            <FAQ data-id="element-28" />
            <FinalCTA data-id="element-29" />
          </>;
    }
  };
  return <div className="min-h-screen bg-surface-bg font-body text-ink-dark selection:bg-teal selection:text-white" data-id="element-30">
      <Navigation data-id="element-31" />
      <main data-id="element-32">{renderPage()}</main>
      <Footer data-id="element-33" />
    </div>;
}